// Escaping text that is about to be written as HTML.
//
// Four controllers build markup with template literals — a combobox option, a
// picker row, an "Add to <group>" label, a food tag — and each carried a
// byte-identical copy of this. Four copies of one security-relevant decision
// is four places to get it wrong, and the one that matters is subtle: it is
// not "does it look escaped", it is whether a food somebody NAMED
// `<img onerror=...>` can execute when it is drawn back to them.
//
// THE BROWSER DOES IT, rather than a hand-written replace chain. Setting
// textContent and reading innerHTML makes the browser's own serialiser
// produce the entities, so it cannot miss a case a regex would.
//
// Extracted by the codebase review, 16 Sep 2026.
export function escapeHtml(text) {
  const node = document.createElement("div")
  node.textContent = text
  return node.innerHTML
}
